/**
 * Newsletter Popup - Native Shopify form (best practice)
 * Shows after delay, handles localStorage to prevent re-showing
 */
(function () {
  "use strict";

  var STORAGE_DISMISSED = "newsletter:popupDismissed";
  var STORAGE_SUBSCRIBED = "newsletter:subscribed";
  var DELAY = 15000;

  var popup = document.getElementById("newsletter-popup");
  if (!popup) return;

  var closeBtn = popup.querySelector(".newsletter-popup__close");
  var isSubscribed = popup.getAttribute("data-subscribed") === "true";

  // Close popup and remember dismissal
  window.closeNewsletterPopup = function () {
    try {
      localStorage.setItem(STORAGE_DISMISSED, "1");
    } catch (e) {}
    popup.style.display = "none";
  };

  // Check if should show popup
  function shouldShow() {
    try {
      return !localStorage.getItem(STORAGE_DISMISSED) && !localStorage.getItem(STORAGE_SUBSCRIBED);
    } catch (e) {
      return false;
    }
  }

  function init() {
    // If form just succeeded, mark as subscribed and show popup with success
    if (isSubscribed) {
      try {
        localStorage.setItem(STORAGE_SUBSCRIBED, "1");
      } catch (e) {}
      popup.style.display = "flex";
      return;
    }

    // Otherwise, check if we should show after delay
    if (!shouldShow()) return;

    setTimeout(function () {
      popup.style.display = "flex";
    }, DELAY);
  }

  // Event listeners
  if (closeBtn) {
    closeBtn.addEventListener("click", window.closeNewsletterPopup);
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && popup.style.display === "flex") {
      window.closeNewsletterPopup();
    }
  });

  // Initialize
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
